function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414L17.414 16l5.293 5.293a1 1 0 0 1-1.414 1.414L16 17.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L14.586 16l-5.293-5.293a1 1 0 0 1 1.414-1.414L16 14.586zM9.828 0h12.344a3 3 0 0 1 2.12.879l6.83 6.828A3 3 0 0 1 32 9.828v12.344a3 3 0 0 1-.879 2.12l-6.828 6.83a3 3 0 0 1-2.121.878H9.828a3 3 0 0 1-2.12-.879l-6.83-6.828A3 3 0 0 1 0 22.172V9.828a3 3 0 0 1 .879-2.12L7.707.877A3 3 0 0 1 9.828 0zm0 2a1 1 0 0 0-.707.293L2.293 9.12A1 1 0 0 0 2 9.828v12.344a1 1 0 0 0 .293.707l6.828 6.828a1 1 0 0 0 .707.293h12.344a1 1 0 0 0 .707-.293l6.828-6.828a1 1 0 0 0 .293-.707V9.828a1 1 0 0 0-.293-.707L22.88 2.293A1 1 0 0 0 22.172 2H9.828z"
});

var SvgAlertError = function SvgAlertError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "b2ce745ca19fbeb40ea5426c7e0694a8.svg";
export { SvgAlertError as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/alert-error.svg
// module id = null
// module chunks = 